import { defineStore } from 'pinia';

export const useSessionMessageStore = defineStore('session_message', {
  state: () => ({
    message: null,
    type: null

  }),
  actions: {
    successMessage(message) {
      this.message = message;
      this.type = 'success';
    },
    infoMessage(message) {
      this.message = message;
      this.type = 'info';
    },
    errorMessage(message) {
      this.message = message;
      this.type = 'error';
    },
    warningMessage(message) {
      this.message = message;
      this.type = 'warning';
    },
    cleanMessage() {
      this.message = null;
      this.type = null;
    }

  },
  getters: {
    hasMessage: (state) => !!state.message,
    getMessageType: (state) => {
      return state.type;
    }
    
  }
})
